import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { setUserService } from "../../subService/userServices";
import { resetFetchedChats } from "../../subService/subServiceChats";
import { resetActiveSubService } from "../../subService/activeSubService";
import { openModal, closeModal } from "../../modal/modal";
import { ModalNames } from "../../../../Constants/modalNames";
import { queryClient } from "../../../store";
export type CreateUserServiceLoadAction = {
  type: string;
  payload: {
    id: number | string;
    shouldCloseModal?: boolean;
    ignore_open_chat?: boolean;
  };
};

export type CreateUserServiceData = {
  data: {
    user_service_id?: number;
    last_user_service_id?: number;
  };
};

const CreateUserService = new ReduxFetchState<
  CreateUserServiceData,
  {
    id: number | string;
    shouldCloseModal?: boolean;
    ignore_open_chat?: boolean;
  },
  any
>("createUserService");

export function* watchCreateUserService(action: CreateUserServiceLoadAction) {
  try {
    const { id, shouldCloseModal, ignore_open_chat } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: CreateUserServiceData = yield axios({
      url: `/api/v1/ai/user-service/create`,
      method: "POST",
      headers: {
        lang,
      },
      data: {
        service_id: id,
        ignore_open_chat: ignore_open_chat ? true : undefined,
      },
    });

    yield put(CreateUserService.actions.loadSuccess({ data: data.data }));
    queryClient.removeQueries({ queryKey: ["getUserHistory", lang] });

    if (data.data.last_user_service_id) {
      yield put(
        openModal({
          name: ModalNames.InProgressService,
          modalProps: { last_user_service_id: data.data.last_user_service_id },
        }),
      );
      yield put(
        setUserService({
          serviceId: Number(id),
          userServiceId: data.data.last_user_service_id,
        }),
      );
      yield put(resetFetchedChats());
      yield put(resetActiveSubService());
    }
    if (data.data.user_service_id) {
      yield put(
        setUserService({
          serviceId: Number(id),
          userServiceId: data.data.user_service_id,
        }),
      );
      yield put(resetFetchedChats());
      yield put(resetActiveSubService());
    }
    if (shouldCloseModal) {
      yield put(closeModal());
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(CreateUserService.actions.loadFailure(e.message));
  }
}

export function* createUserServiceSagas() {
  yield takeEvery(CreateUserService.actionTypes.load, watchCreateUserService);
}

export function useCreateUserService() {
  const { loading, data, ...createUserServiceState } = useAppSelector(
    (state) => state.createUserService,
  );
  const dispatch = useAppDispatch();

  const dispatchCreateUserService = useCallback(
    (data: { id: number | string; shouldCloseModal?: boolean; ignore_open_chat?: boolean }) => {
      dispatch(CreateUserService.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...createUserServiceState,
    dispatchCreateUserService,
    createUserServiceLoading: loading,
    createUserServiceData: data,
  };
}

export const {
  actionTypes: createUserServiceActionsTypes,
  actions: createUserServiceActions,
  reducer: createUserServiceReducer,
} = CreateUserService;
